import is from "@sindresorhus/is";

const wpGetPostsByCategoryId = (axios, categoryId, options) =>
  new Promise((resolve, reject) => {
    const categories = is.array(categoryId) ? categoryId.join(",") : categoryId;
    const page = options?.page ?? 1;
    const perPage = options?.perPage ?? 4;
    const queryParams = [];

    queryParams.push(`categories=${categories}`);
    queryParams.push(`page=${page}`);
    queryParams.push(`per_page=${perPage}`);
    queryParams.push("_fields=id,date,title,content,categories,excerpt,featured_media,_links.wp:featuredmedia");
    queryParams.push("_embed");

    Promise.resolve()
      .then(() => axios.get(`posts?${queryParams.join("&")}`))
      .then(axiosResponse => {
        const data = axiosResponse.data;

        if (!is.array(data)) throw new Error("Invalid WP response, while getting posts.");
        resolve(data);
      })
      .catch(error => reject(error));
  });

export default wpGetPostsByCategoryId;
